import defaultMeta from '../metadata/default.html?raw';
import connexusMeta from '../metadata/connexuschurch.html?raw';
import centrikidMeta from '../metadata/centrikid.html?raw';
import fugeMeta from '../metadata/fuge.html?raw';
import studentlifeMeta from '../metadata/studentlife.html?raw';
import sbcMeta from '../metadata/sbc.html?raw';

export const brands = [
  {
    origin: 'GRID',
    theme: 'grid',
    hostIncludes: 'ministrygrid',
    orgIds: {},
    isSSO: true,
    metadataHtml: defaultMeta,
  },
  {
    origin: 'CONNEXUS',
    theme: 'connexus',
    hostIncludes: 'connexuschurch',
    orgIds: {
      INT: 'b16881c0-0e66-4101-d2a4-c370266e9b13',
      UAT: '89d312b2-2cea-4585-9967-9ca5662a5616',
      PROD: '29d406f2-1238-4951-e51f-18cd909cc1de',
    },
    isSSO: false,
    metadataHtml: connexusMeta,
  },
  {
    origin: 'CENTRIKID',
    theme: 'centrikid',
    hostIncludes: 'centrikid',
    orgIds: {
      INT: '33c6e35e-fc36-46cc-eaf4-68991808d6a6',
      UAT: '5245a3b8-0002-486b-91ab-ec754a94ed42',
      PROD: '7a01520f-1445-4af7-f581-1a7a74655d33',
    },
    isSSO: true,
    metadataHtml: centrikidMeta,
  },
  {
    origin: 'FUGE',
    theme: 'fuge',
    hostIncludes: 'fuge',
    orgIds: {
      INT: '782404e6-29b5-41d4-a756-bf29f2a7c440',
      UAT: 'a9d8988b-bb40-453d-a67c-ffb778d2bb8a',
      PROD: 'bc804842-f387-4e13-ce1d-c67d2774ee17',
    },
    isSSO: true,
    metadataHtml: fugeMeta,
  },
  {
    origin: 'STUDENTLIFE',
    theme: 'studentlife',
    hostIncludes: 'studentlife',
    orgIds: {
      INT: 'd656634b-956f-47bc-b29c-2d1f678875a5',
      UAT: 'bb03fb2c-a6f9-4fb5-d13f-b77ee92cc226',
      PROD: '8548eed1-2e54-42d3-ad93-8b1048f2231c',
    },
    isSSO: true,
    metadataHtml: studentlifeMeta,
  },
  {
    origin: 'SBC',
    theme: 'sbc',
    hostIncludes: 'sbc',
    orgIds: {
      INT: 'cd3372ac-5c17-4a32-82d2-df5a467e931e',
      UAT: 'eb30a57f-8621-4552-ea4b-ede2b1131411',
      PROD: '4214d63f-37ed-487e-e322-0eacb5026a52',
    },
    isSSO: false,
    metadataHtml: sbcMeta,
  },
];
